export const PUBLIC_CONTRACT_STATUSES = [
  "PENDING",
  "PAID",
  "SHIPED",
  "COMPLETED",
  "ABANDONED",
  "EXPIRED",
  "CANCELED",
] as const;

export type PublicContractStatus = (typeof PUBLIC_CONTRACT_STATUSES)[number];

export const PUBLIC_CONTRACT_PAYMENT_STATUSES = [
  "PENDING",
  "PAID",
  "FAILED",
] as const;

export type PublicContractPaymentStatus =
  (typeof PUBLIC_CONTRACT_PAYMENT_STATUSES)[number];

export interface ContractBuyerInfo {
  firstName?: string;
  lastName?: string;
  fullName?: string;
  email?: string;
  phoneNumber?: string;
  buyerState?: string;
  buyerCity?: string;
  buyerAddress?: string;
  id?: string;
}

/** Nested product relation — API often nests this on `productId` (same as orders). */
export interface PublicContractProductRef {
  id?: string;
  name?: string;
  title?: string;
  photos?: string[];
  price?: number;
  colors?: string[] | string;
  [key: string]: any;
}

export interface PublicContractItem {
  id?: string;
  name?: string;
  productName?: string;
  /** Catalog product relation, or a plain UUID string. */
  productId?: string | PublicContractProductRef | null;
  product?: string | PublicContractProductRef | null;
  quantity?: number;
  productQuantity?: number | string;
  price?: number;
  vendorDiscountedPrice?: number;
  totalCost?: number;
  photos?: string[];
  [key: string]: any;
}

export interface PublicContract {
  id: string;
  title?: string;
  description?: string;
  contractCode?: string;
  code?: string;
  status?: PublicContractStatus | string;
  paymentStatus?: PublicContractPaymentStatus | string;
  vendor?: any;
  vendorId?: any;
  buyer?: any;
  buyerId?: any;
  buyerInfo?: ContractBuyerInfo;
  contractItems?: PublicContractItem[];
  contractItem?: PublicContractItem[];
  items?: PublicContractItem[];
  products?: PublicContractItem[];
  shippingDate?: string;
  estimatedDeliveryDate?: string;
  estimatedWeight?: number;
  actualWeight?: number | null;
  deliveryCost?: number;
  itemsAmount?: number;
  totalAmount?: number;
  amount?: number;
  withinCity?: boolean;
  shipoutState?: string | { name?: string; title?: string };
  shipoutCity?: string | { name?: string; title?: string };
  shipoutStateId?: any;
  shipoutCityId?: any;
  paymentOption?: string;
  paymentRef?: string;
  publicUrl?: string;
  shareUrl?: string;
  paymentLink?: string;
  createdAt?: string;
  updatedAt?: string;
  expiresAt?: string;
  [key: string]: any;
}

export interface PaginationMeta {
  totalItems: number;
  totalPages: number;
  itemsPerPage: number;
  currentPage: number;
}

export interface PublicContractListResult {
  items: PublicContract[];
  meta: PaginationMeta;
}

export interface AdminPublicContractListParams {
  page?: number;
  limit?: number;
  status?: PublicContractStatus | string | null;
  paymentStatus?: PublicContractPaymentStatus | string | null;
  vendorId?: string | null;
  contractCode?: string | null;
  search?: string | null;
  dateFrom?: string | null;
  dateTo?: string | null;
}

export type PublicContractCounts = Record<string, number>;
